import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Modal } from 'reactstrap'

import Loading from '../../../../templates/UI/Loading/Loading'
import callAPI from '../../../../helpers/callAPI'
import ReviewApplication from './ReviewApplication/ReviewApplication'
import DuplicateModal from './DuplicateModal/DuplicateModal'
import VerifyApplication from './VerifyApplication/VerifyApplication'
import ApplicationListItem from './ApplicationListItem/ApplicationListItem'

// TODO: Need to fix card for smaller screens; table stretches out of card

const Applications = ({ manager, showSystemMessage, mode }) => {
    const [applications, setApplications] = useState([])
    const [dataLoaded, setDataLoaded] = useState(false)
    const [affiliateId, setAffiliateId] = useState() // For Modal
    const [showApplicationModal, setShowApplicationModal] = useState(false)
    const [showDuplicateModal, setShowDuplicateModal] = useState(false)
    const [updateList, setUpdateList] = useState(false)

    let dependency = [manager]

    useEffect(() => {        
        setDataLoaded(false)
        getApplications()
    }, dependency)

    const getApplications = () => {
        let url = ''

        if (mode === 'affiliate_manager') {
            url = `affiliates/applications?adminId=${manager.id}`
            dependency = [manager]
        } else if (mode === 'compliance') {
            url = `compliance/affiliates/applications`
        } else if (mode === 'marketing'){
            url = `compliance/affiliates/applications?marketing=true`
        }

        setDataLoaded(false)

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    setApplications(result.applications)
                    setDataLoaded(true)
                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                    setDataLoaded(true)
                }
            })
            .catch((error) => {
                showSystemMessage('error', 'An error occurred while fetching affiliate applications')
            })
    }

    const handleClick = (e, affiliateId) => {
        e.preventDefault()
        setAffiliateId(affiliateId)
        if (mode === 'compliance' || mode === 'marketing'){
            window.open(`/affiliate/${affiliateId}/application/verify`, '_blank', 'height=750,width=800')
        } else {
            setShowApplicationModal(true)
        }
        
    }

    const toggleModal = () => {
        setShowApplicationModal(false)
        setShowDuplicateModal(false)
        if (updateList) {
            getApplications()
        }
    }

    const handleDupClick = (affiliateId) => {
        setAffiliateId(affiliateId)
        setShowDuplicateModal(true)
    }

    const handleClose = () => {
        setShowApplicationModal(false)
        getApplications()
    }

    let applicationModal

    if (mode === 'affiliate_manager') {
        applicationModal = (
            <Modal isOpen={showApplicationModal} toggle={toggleModal} className="modal-lg">
                <ReviewApplication showSystemMessage={showSystemMessage} affiliateId={affiliateId} handleReviewClose={handleClose} manager={manager} setUpdateList={setUpdateList} />
            </Modal>
        )
    } else if (mode === 'compliance' || mode === 'marketing') {
        applicationModal = (
            <Modal isOpen={showApplicationModal} toggle={toggleModal} className="modal-lg">
                <VerifyApplication showSystemMessage={showSystemMessage} affiliateId={affiliateId} handleReviewClose={handleClose} />
            </Modal>
        )
    }

    return (
        <div className="card mb-3 w-100 overflow-auto">
            {applicationModal}
            {showDuplicateModal && <DuplicateModal showSystemMessage={showSystemMessage} affiliateId={affiliateId} handleClose={toggleModal} isOpen={showDuplicateModal} />}

            <div className="card-header justify-content-between d-flex">
                <div>{mode === 'marketing' ? 'Marketing ' : ''}Applications</div>
                <div>
                    In queue:   <span>{mode === 'affiliate_manager' ?
                                        <Link to={`/affiliates/applications?adminId=${manager.id}`}>{applications.length}</Link>
                                    :  mode === 'compliance' ?
                                        <Link to={`/compliance/applications?adminId=${manager.id}`}>{applications.length}</Link>
                                    :
                                        <Link to={`/compliance/applications?adminId=${manager.id}&marketing=true`}>{applications.length}</Link>
                                    }
                                </span>
                </div>
            </div>
            <div className="card-body p-0" style={{ fontSize: '0.9rem' }}>
                {dataLoaded ? (
                    applications.length === 0 ? (
                        <div className="p-2">No stats available</div>
                    ) : (
                        <table className="table table-striped table-hover table-responsive-sm m-0">
                            <thead className="text-secondary">
                                <tr>
                                    <th>ID</th>
                                    <th>Affiliate</th>
                                    <th width="100px">Exp</th>
                                    <th width="100px">Country</th>
                                    <th width="125px">Local/Best Time</th>
                                    <th>Date</th>
                                    {(mode === 'compliance' || mode === 'marketing') && <th>Dup</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {applications.slice(0, 20).map((app) =>
                                    <ApplicationListItem key={app.affiliate.id} application={app} mode={mode} handleDupClick={handleDupClick} handleClick={handleClick} />
                                )}
                            </tbody>
                        </table>
                    )
                ) : (
                    <Loading></Loading>
                )}
            </div>
        </div>
    )
}

export default Applications
